<template>
   <div id="welcome-page">
      <div id="divAnnounce" v-if="showAnnounce" v-cloak>
         <div class="alert alert-danger small announcement">
            <span v-html="announcement"></span>
         </div>
      </div>

      <div class="mid-box">
         <!-- Log In Initially -->
         <div class="login">
            <form :class="{ 'padb-12': !isInternalAdmin }">
               <h2 class="ml-corp">Log In</h2>

               <!-- W A I T I N G -->
               <div v-if="lprogress == 'WAIT'">
                  <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
               </div>

               <!-- Good Appointment Link -->
               <div v-if="lprogress == 'WELCOME'">
                  <div class="ml-corp marb-24 font-smaller">
                     <p>
                        Welcome to {{ appTitle }}. The first step to getting appointed
                        is to sign up. To begin, click the Next button below and then
                        click the "Sign Up Now" link on the following page.
                     </p>
                     <p>If you've already signed UP, just sign IN instead.</p>
                  </div>
                  <button type="button" class="btn ml-btn ml-bk-black ml-white ml-h-orange" v-on:click="handleSignUp">
                     NEXT
                     <i class="fi-interface-next"></i>
                  </button>
               </div>

               <!-- Error Appointment Link check -->
               <div v-if="lprogress == 'ERROR'">
                  <div class="text-danger marb-24 font-smaller">
                     Something on our end went wrong when validating the link you
                     provided. Please click on the <b>OK</b> button to try signing up
                     again or contact support if the problem persists.
                  </div>
                  <button type="button" class="btn ml-btn ml-bk-black ml-white ml-h-orange" v-on:click="handleBack">
                     <i class="fi-interface-previous"></i>
                     OK
                  </button>
               </div>

               <!-- Hold here while they determine what to do -->
               <div v-if="lprogress == 'HOLD'">
                  <div class="ml-corp marb-24 font-smaller">
                     <div class="text-danger" v-if="message != ''">
                        Profile Saved Successfully!
                     </div>
                     <div v-else>Welcome to {{ appTitle }}.</div>
                     <div class="padb-12">Click "Next" to log in.</div>

                     <button type="button" class="btn ml-btn ml-bk-black ml-white ml-h-orange marb-12"
                             v-on:click="handleSignUp" :disabled="authInProg">
                        NEXT
                        <i class="fi-interface-next"></i>
                     </button>
                     <div>
                        If you are NEW, you'll need to get an email invitation from the
                        agency that is recruiting you. If you have any questions, please
                        <a :href="mktMail">contact us</a>.
                     </div>
                  </div>
               </div>

               <div class="mart-24 marb-12">
                  <a href="#" @click.prevent="doc('NewUserReg.pdf')" class="btn help-btn">
                     <i class="fas fa-file-pdf"></i>
                     HELP: NEW USERS
                  </a>
               </div>
               <div :class="{ 'marb-24': !isInternalAdmin }">
                  <a href="#" @click.prevent="doc('ExistingUserReg.pdf')" class="btn help-btn">
                     <i class="fas fa-file-pdf"></i>
                     HELP: EXISTING EZ-APPOINT USERS
                  </a>
               </div>
            </form>
         </div>
         <div v-if="lprogress === 'HOLD' && isInternalAdmin" class="login" style="padding-top: 0px">
            <div class="ml-corp marb-24 font-smaller">
               Please enter an existing user's email to spoof.
            </div>
            <div class="form-group row" style="align-items: center; justify-content: center">
               <div class="col-sm-8" style="padding-left: 0px">
                  <input type="text" class="form-control" v-model="emailToSpoof" placeholder="Email">
               </div>
               <div>
                  <button type="button" class="btn ml-btn ml-bk-black ml-white ml-h-orange" v-on:click="spoof">
                     SPOOF
                     <i class="fi-interface-next"></i>
                  </button>
               </div>
            </div>
         </div>
      </div>

      <div class="container-fluid stand-box">
         <div class="container">
            <div class="row">
               <div class="col-sm-6 padt-12 disclaimer">
                  <h3>ManhattanLife - What We Stand For</h3>
                  <p>
                     <strong>Stability</strong> - ManhattanLife has been dedicated to
                     serving America successfully since 1850. Our business has
                     prospered for more than {{ years }} years because we have held
                     fast to a high ethical standard of fair minded and quality service
                     to our policyholders.
                  </p>

                  <p>
                     <strong>Innovation</strong> - With the cost of employee benefits
                     rising at ever increasing annual rates, employers today are faced
                     with daunting health care challenges. Many small and mid-size
                     employers are unable to afford Major Medical coverage for their
                     employees. As a leading company in providing life and health
                     benefits, ManhattanLife designs innovative products and services.
                  </p>

                  <p>
                     <strong>Responsive Service</strong> - Recognized by industry
                     consultants for our “Responsive Home Office,” we pride ourselves
                     on providing the highest quality customer service to our
                     customers. Our experienced and professional staff realizes that
                     clients have a choice and we are committed to providing them with
                     competitive, fast, efficient and personal service. The Companies
                     of ManhattanLife are committed to you.
                  </p>
               </div>
               <div class="col-sm-6 padt-12 disclaimer text-right">
                  <div class="marb-24">
                     <a href="https://www.ManhattanLife.Com" target="_blank">
                        <img src="../assets/images/ml_logo_white.svg" alt="ManhattanLife" />
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import Const from "@/services/Constants";
import "bootstrap";
import { checkOrGetGoodLink } from "@/utils/appointment-utils";
import Vue from "vue";
import { mapGetters } from 'vuex';

export default {
   data() {
      return {
         announcement: "",
         showAnnounce: false,
         username: "",
         emailAddress: "",
         from: null,

         // Values are:
         // * WAIT - Thinking/Loading/Redirecting...
         // * WELCOME - The have a good link, give them instructions for how to sign-up
         // * PROFILE - They are a user in Azure but local profile info does not exist
         // * ERROR - They have a link but it is invalid
         // * HOLD - They aborted the sign in / sign-up

         lprogress: "WAIT",
         lprogressOLD: "",
         appTitle: process.env.VUE_APP_TITLE,
         message: "",
         c: new Const(),
         years: new Date().getFullYear() - 1850,
         mktMail: `mailto:${process.env.VUE_APP_MKT_EMAIL}`,
         emailToSpoof: undefined
      };
   },
   async mounted() {
      await this.initialize();
   },
   computed: {
      ...mapGetters(['isInternalAdmin']),
      authInProg() {
         return this.$store.getters.authInProgress;
      },
      isAuthenticated() {
         return Vue.prototype.$auth.isAuthenticated();
      },
   },
   watch: {
      authInProg(newState, oldState) {
         if (newState && !oldState) {
            // changing to true
            this.lprogressOLD = this.lprogress;
            this.lprogress = "WAIT";
         } else if (!newState && oldState) {
            // changing to false
            this.lprogress = this.lprogressOLD;
            this.lprogressOLD = "WAIT";
         }
      },
   },
   methods: {
      handleBack() {
         this.lprogress = "HOLD";
      },
      async handleSignUp() {
         this.lprogress = "WAIT";
         this.$store.commit("updateAuthInProgress", true);
         if (
            this.isAuthenticated &&
            this.$store.getters.appointmentLink.search("EXT") == 0
         ) {
            //  const goHomeCallBack = () => this.$router.push("home").catch((f) => {});
            this.completeInvitation();
         } else if (
            this.isAuthenticated && 
            this.$store.getters.appointmentLink.search ("MD") == 0
         ) {
            this.completeMDInvitation();
         } else {

            // If not authenticated, force login
            this.$router.push("home").catch((f) => { });
         }
      },
      async initialize() {
         this.lprogress = "WAIT";
         if (this.authInProg) {
            return;
         }

         if (localStorage[this.c.STOR_UPD_PASSWORD] == "TRUE") {
            this.message = "Your password was successfully reset.";
         }

         if (this.$route.params.lnk == "PROFILE") {
            this.lprogress = "PROFILE";
            return;
         }

         if (this.$route.params.lnk == "HOLD") {
            this.lprogress = "HOLD";
            return;
         }

         if (
            this.$route.params.lnk &&
            this.$route.params.lnk != "" &&
            this.$route.params.lnk != this.$store.getters.appointmentLink
         ) {
            checkOrGetGoodLink(this.$route.params.lnk)
               .then((link) => {
                  if (!link ) {
                     window.location.href = process.env.VUE_APP_B2C_REDIRECT_URL
                     return
                  }                  
                  this.$store.commit("updateAppointmentLink", link);
                  //Once we get a good link.  Update $router with a good link.
                  this.$router // update url only to reflect new valid link
                     .push({ path: `/${link}`, replace: true })
                     .catch((e) => { });
                  this.appointmentLink = link;
                  this.lprogress = "WELCOME";
               })
               .catch((er) => {
                  this.lprogress = "ERROR";
               });
         } else {
            // Load Announcements
            await this.$store.dispatch("getAnnouncements");
            this.announcement = this.$store.getters.announceHtml;
            if (typeof this.announcement != "undefined") {
               this.showAnnounce = true;
            }

            this.lprogress = "HOLD";
         }
      },
      doc(pth) {
         let payload = {
            AppUserId: this.appUserId,
            DownloadFileType: 4, // CorpDoc
            Path: pth,
            Title: pth,
         };

         this.$swal({
            title: "Download Initiated",
            html: "Please wait...",
            timer: 1000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
            willOpen: () => {
               this.$swal.showLoading();
            },
            willClose: () => { },
         });

         this.$document.apiDownload(payload, true).then(
            (r) => {
               if (this.$document.errors.length > 0) {
                  this.$swal(
                     "Document Unavailable",
                     "Unfortunately we are having trouble downloading your document at this time. " +
                     this.$document.errors[0],
                     "error"
                  );
               }
            },
            (e) => {
               this.$swal(
                  "Document Unavailable",
                  "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                  "error"
               );
            }
         );
      },
      async completeMDInvitation() {
         let alink = this.$store.getters.appointmentLink;
         let userId = this.$store.getters.appUser.userId;
         let userName = this.$store.getters.appUser.userName;

         //No link.  No need to update MD.  It means MD has been updated in User Creation.  
         if (alink && alink != '') {
            //Make sure all required fields are not missing
            if (userId && userName) {
               let payload = {
                  UserId: userId,
                  UserName: userName,
                  AppointmentLink: alink
               }

               await Vue.prototype.$user.updateMD(payload)
                     .then(async(r) => {                        
                        if (r != null) {
                           const result = this.$auth.parseMDUpdate(r);

                           if (!result || result.errorCode) {
                              await this.$auth.handleError(result.errorCode);
                              await this.$auth.logout();
                              return;
                           }

                           if (r.isUpdated == true) {
                              //Update appointment Link to blank if it is successful, so it won't display in Home page.                           
                              this.$store.commit('updateAppointmentLink', '')
                              this.$swal(
                                 "Marketing Director Update Sccuessfully",
                                 "Marketing Director was updated successfully.  Please make sure you logout and log back in to see the new hierarchy.",
                                 "success"
                              )                           
                              //Route to home page afterword.  
                              this.$router.push("home").catch((f) => {});
                           }
                        }
                     })
                     .catch(async(err) => {
                        await Vue.prototype.$swal(
                           "Problem Update Marketing Director",
                           "Try logging in again or user the invitation link you were sent to login.  Please contact support if the problem persists",
                           "error"
                        )
                        await this.$auth.logout()
                        this.$store.commit('updateAuthInProgress',false)
                        return
                     })
            } else {
               await Vue.prototype.$swal(
                  "Problem Update Marketing Director",
                  "Missing Info. Please contact support if the problem persists",
                  "error"
               )
               await this.$auth.logout()
               this.$store.commit('updateAuthInProgress',false)
               return         
            }
         }
      },
      async completeInvitation() {
         const wasInviteAccepted =
            await Vue.prototype.$auth.isUserInvitationAccepted()
         if (!wasInviteAccepted) {
            const {
               appUser: { externalId: uniqueId },
               userClaims,
            } = this.$store.getters;
            await this.$auth

               .createAppUser({
                  idTokenClaims: {
                     extension_SSOUserId: userClaims.extension_SSOUserId,
                     given_name: userClaims.given_name,
                     family_name: userClaims.family_name,
                  },
                  uniqueId,
               })
               .then((resp) => {
                  this.$router.push("home").catch((f) => { })
               })
               .catch(async (err) => {
                  const err_type =
                     err.message === "error_link_missing"
                        ? err.message
                        : !wasInviteAccepted
                           ? "ext_error"
                           : "create_user_error"
                  await this.$auth.handleError(err_type, err)
                  await this.$auth.logout()
               });
         }
      },
      async spoof() {
         const email = this.emailToSpoof;
         this.$store.commit("updateAuthInProgress", true);
         const spoofResult = await this.$auth.spoofEmail(email);
         this.$store.commit("updateAuthInProgress", false);
         if (!spoofResult) {
            return;
         }
         this.$router.push("home");
      }
   },
}
</script>

<style lang="scss">
@import "../assets/css/colors.scss";

blockquote {
   padding: 12px;
   border: 1px solid #ddd;
   font-family: "Courier New", Courier, monospace;
   font-size: smaller;
}

.img-fluid {
   min-width: 100%;
}

#welcome-page {
   opacity: 1;
   transition: opacity 0.5s;
   width: 100%;
   /* display: flex; */
   height: 100%;
   min-height: 800px;
   justify-content: center;
   align-items: center;
   background-color: white;
   background: url("../assets/images/back.png") center center no-repeat;
   background-size: cover;
   z-index: 10000;
}

.login {
   background-color: #fff;
   min-width: 400px;
   width: 400px;
   max-height: 600px;
   max-width: 400px;
   transition: background-color 0.5s;
   padding: 12px;
   text-align: center;
   margin: 0 auto;
   position: relative;
}

#divAnnounce {
   position: absolute;
   top: 24px;
   left: 24px;
}

button i:first-child {
   padding-right: 0px !important;
}

[v-cloak] {
   display: none;
}

.mid-box {
   display: block;
   min-height: 800px;
   height: 100%;
   width: 100%;
   padding: 50px 0 0 0;
}

.stand-box {
   display: block;
   width: 100%;
   background-color: #000;
}

.disclaimer {
   padding: 12px 15px 30px;
   font-weight: 100;
   font-size: 0.75em;
   color: #fff;
}

.disclaimer a,
.disclaimer a:visited {
   text-decoration: none;
   color: #fff;
}

.disclaimer a:hover {
   color: $corp-yellow;
}

.disclaimer img {
   width: 283px;
   height: 120px;
}

.help-btn {
   color: $corp-color  !important;
   background-color: #fff;
   border: 1px solid $corp-color;
   margin-right: 12px;
   margin-bottom: 12px;
   width: 80%;
   outline-color: transparent;
   box-shadow: none;
   outline-style: none !important;
}

.help-btn:focus {
   box-shadow: none;
   outline-style: none !important;
   outline: 0;
}

.help-btn:hover {
   color: #000 !important;
   background-color: $corp-color;
   font-weight: normal;
}

.help-btn i {
   margin-right: 6px;
}

.help-btn {
   color: $corp-color  !important;
   background-color: #fff;
   border: 1px solid $corp-color;
   margin-right: 12px;
   margin-bottom: 12px;
   width: 80%;
   outline-color: transparent;
   box-shadow: none;
   outline-style: none !important;
}

.help-btn:focus {
   box-shadow: none;
   outline-style: none !important;
   outline: 0;
}

.help-btn:hover {
   color: #000 !important;
   background-color: $corp-color;
   font-weight: normal;
}

.help-btn i {
   margin-right: 6px;
}
</style>

